import React from 'react';

interface IComboFieldContext {
  invalid: boolean;
}

export const ComboFieldContext = React.createContext<IComboFieldContext>({
  invalid: undefined,
});
